/* eslint-disable no-tabs */
import styled from 'styled-components'

export const Li = styled.li`
	span {
		position: relative;
  	left: -10px;
	}
`
